import { VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { ResponsesReserveRatesResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList, Text } from 'native-base';
import React from 'react';

import { dataContent } from '../../../../../../constants';
import { DetailsIRRateItem } from '../DetailsIRRateItem';
import { TableHead } from '../TableHead';

interface DetailsIRRateTableProps {
  data: ResponsesReserveRatesResponse[];
}

export const DetailsIRRateTable: React.FC<DetailsIRRateTableProps> = ({ data }) => {
  const viewportType = useBreakpointValue({ base: 'tablet', lg: 'desktop' });
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { tableHead, widthCols } = dataContent.pensionIRRateStatements;

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
        Abertura de Alíquotas de IR
      </Text>
      <Box>
        {!isMobile && (
          <TableHead viewportType={viewportType} tableHead={tableHead} widthCols={widthCols} />
        )}
        <FlatList
          data={data}
          showsVerticalScrollIndicator={false}
          keyExtractor={(_, index) => `details-ir-rate-table-${index}`}
          renderItem={({ item }) => <DetailsIRRateItem item={item} />}
        />
      </Box>
    </VStack>
  );
};
